export default __webpack_public_path__ + "static/media/doctor.3b4d3e97.png";